import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate {

	constructor(private router: Router) { }

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (this.isLoggedInAdmin) {
			return true;
		}
		localStorage.setItem('isLoggedInAdmin', 'false');
		localStorage.removeItem('currentAdminToken');
		
		this.router.navigate(['/login']);
		return false;
	}

	get isLoggedInAdmin(): boolean {
		let status = false;
		if (localStorage.getItem('isLoggedInAdmin') == "true") {
			status = true;
		}
		else {
			status = false;
		}
		return status;
	}
}

